var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { useAnimateTransition } from '../hooks';
import { darkThemeStyle } from '../theme';
import Card from './card';
function NotificationInternal(_a) {
    var action = _a.action, _b = _a.closable, closable = _b === void 0 ? false : _b, closeButtonOverride = _a.closeButtonOverride, description = _a.description, _c = _a.inverted, inverted = _c === void 0 ? false : _c, _d = _a.mode, mode = _d === void 0 ? 'inline' : _d, onClose = _a.onClose, _e = _a.size, size = _e === void 0 ? 'medium' : _e, title = _a.title, _f = _a.variant, variant = _f === void 0 ? 'info' : _f, restProps = __rest(_a, ["action", "closable", "closeButtonOverride", "description", "inverted", "mode", "onClose", "size", "title", "variant"]);
    var _g = __read(useState(true), 2), isOpen = _g[0], setIsOpen = _g[1];
    var isAnimating = useAnimateTransition(isOpen, 400);
    function handleClose() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setIsOpen(false);
    }
    return isAnimating ? (_jsx(Card, __assign({ css: inverted && darkThemeStyle }, {
        action: action,
        closable: closable,
        closeButtonOverride: closeButtonOverride,
        description: description,
        mode: mode,
        size: size,
        title: title,
        variant: variant,
    }, restProps, { isVisible: isOpen, onClose: handleClose }))) : null;
}
export default NotificationInternal;
